import { createStore, applyMiddleware } from 'redux'
import { createWrapper } from 'next-redux-wrapper'
import thunkMiddleware from 'redux-thunk'

const reduxDevToolsExtension = require('@redux-devtools/extension')

const isDev = process.env.NODE_ENV !== 'production'

let composeWithDevTools
if (isDev) {
  composeWithDevTools = reduxDevToolsExtension.composeWithDevTools
}

const getMiddleware = () => {
  if (isDev) {
    const composeEnhancers = composeWithDevTools({
      trace: true,
    })
    return composeEnhancers(applyMiddleware(thunkMiddleware))
  }
  return applyMiddleware(thunkMiddleware)
}

const initializeStore = () => {
  const middleware = getMiddleware()

  const store = createStore(
    (state = {}) => state,
    {},
    middleware,
  )

  return store
}

export default createWrapper(initializeStore)
